import mainFalls from "../Images/Courtallam - Main falls.jpg";
import fiveFalls from "../Images/coutrallam-five falls.jpg";
import oldFalls from "../Images/Tenkasi-Kasi vishwanathar temple.jpg";
import tigerFalls from "../Images/coutrallam-shenbahadevi falls.avif";
import shenbagadevi from "../Images/coutrallm-tiger-falls.webp";
import chitraruvi from "../Images/Tenkasi-Thirumali kovil.jpg";

function Places() {
  return (
    <section className="places py-5">
      <div className="container">

        {/* Main Falls */}
        <div className="row align-items-center place-row mb-5">
          <div className="col-lg-6">
            <img src={mainFalls} alt="Main Falls" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Main Falls, Coutrallam</h2>
            <p>
              Courtallam Main Falls, also known as Kutralam Main Falls, is one of the most famous 
              and beautiful waterfalls in Tamil Nadu, located in the Tenkasi district at the 
              foothills of the majestic Western Ghats. It is widely known as the "Spa of South 
              India" because the water that flows through the dense forests is believed to pass over 
              numerous medicinal herbs and plants, making it refreshing and beneficial for the body 
              and mind.The waterfall has a height of approximately 60 metres (197 feet), and the 
              force of the water creates a natural shower that attracts thousands of visitors every 
              year. During the southwest monsoon season, from June to September, the waterfall 
              becomes especially spectacular, with a continuous flow of crystal-clear water 
              surrounded by lush green hills and a cool, pleasant climate. The Tamil Nadu government 
              has developed safe bathing areas, changing rooms, and other facilities, making it a 
              popular destination for families, pilgrims, and tourists alike.Apart from its natural 
              beauty, Courtallam also holds cultural and religious significance, as it is located 
              near the ancient Kutralanathar Temple, dedicated to Lord Shiva, which draws many 
              devotees throughout the year. Visitors to Courtallam can also explore several nearby 
              waterfalls, including Five Falls, Old Courtallam Falls, Tiger Falls, and Shenbaga Devi 
              Falls, each offering a unique and memorable experience.
            </p>
          </div>
        </div>

        {/* Five Falls */}
        <div className="row align-items-center place-row mb-5">
          <div className="col-lg-6">
            <img src={fiveFalls} alt="Five Falls" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Five Falls, Coutrallam</h2>
            <p>
              Five Falls, locally known as Aintharuvi, is one of the most popular and picturesque 
              waterfalls in Courtallam, located in the Tenkasi district of Tamil Nadu at the 
              foothills of the Western Ghats. The waterfall gets its name because the water 
              naturally splits into five separate streams before reaching the ground, creating a 
              unique and beautiful sight. According to local tradition, the five streams represent 
              the five-headed serpent (Adisesha) or the five elements of nature—earth, water, fire, 
              air, and space. Surrounded by lush green forests and scenic hills, Five Falls offers 
              a refreshing and peaceful environment that attracts thousands of tourists and pilgrims 
              every year. The cool, clear water is believed to contain medicinal properties because 
              it flows through forests rich in herbal plants, making it a natural therapeutic bath. 
              The best time to visit is during the monsoon season, from June to September, when the 
              waterfall is at its fullest and the surrounding landscape is vibrant and green. The 
              bathing area is well maintained, with separate sections for men and women to ensure 
              safety and comfort. Nearby, visitors can find small shops selling herbal oils, local 
              snacks, fresh fruits, and souvenirs, adding to the overall experience. 
            </p>
          </div>
        </div>

        {/* Old Courtallam */}
        <div className="row align-items-center place-row mb-5">
          <div className="col-lg-6">
            <img src={oldFalls} alt="Old Courtallam" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Kasi Viswanathar Temple, Tenkasi</h2>
            <p>
              The Kasi Viswanathar Temple is one of the most famous and ancient Hindu temples in 
              Tamil Nadu, located in the heart of Tenkasi. Dedicated to Lord Shiva, who is worshipped 
              here as Kasi Viswanathar, and Goddess Parvati, worshipped as Ulagamman, the temple is 
              an important pilgrimage centre for devotees from across South India. It was built by 
              the Pandya king Parakrama Pandyan during the 13th century, with later additions by the 
              Madurai Nayak rulers, and is a fine example of traditional Dravidian architecture. The 
              temple is especially renowned for its magnificent nine-tiered Rajagopuram, which rises 
              to about 180 feet and is adorned with beautifully carved sculptures depicting scenes 
              from Hindu mythology. According to legend, the king wished to bring a Shiva Lingam from 
              Kashi (Varanasi), but Lord Shiva appeared in his dream and instructed him to build the 
              temple at Tenkasi instead, giving the town its name, which means "Southern Kashi." 
              Devotees believe that worshipping at this temple brings spiritual benefits equal to 
              visiting the sacred Kashi Vishwanath Temple in Varanasi. The temple complex features 
              intricately carved stone pillars, spacious halls, numerous shrines, and inscriptions 
              that reveal the rich cultural and historical heritage of the Pandya kingdom. Major 
              festivals such as Maha Shivaratri, Masi Magam, Navaratri, Aippasi Thirukalyanam, and 
              Thiruvathirai are celebrated with great devotion, attracting thousands of pilgrims 
              every year.
            </p>
          </div>
        </div>

        {/* Tiger Falls */}
        <div className="row align-items-center place-row mb-5">
          <div className="col-lg-6">
            <img src={tigerFalls} alt="Tiger Falls" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Shenbagadevi Falls</h2>
            <p>
              Shenbaga Devi Falls is a beautiful and scenic waterfall located deep within the forests 
              of the Western Ghats near Courtallam. Named after Goddess Shenbaga Devi, whose temple is
              situated close to the waterfall, it is considered both a natural attraction and a sacred
              pilgrimage site. Reaching the falls requires a moderate trek through dense forests, 
              offering visitors an adventurous experience surrounded by rich biodiversity and 
              breathtaking landscapes. The waterfall cascades from a considerable height into a clear
              pool, creating a peaceful and refreshing atmosphere. The surrounding forests are filled
              with medicinal plants, colourful flowers, and a variety of birds and wildlife, making 
              the area attractive to nature lovers and trekkers. Every year, during the Chithirai 
              Pournami festival, thousands of devotees visit the Shenbaga Devi Temple to seek the 
              blessings of the goddess. The cool climate, crystal-clear water, and tranquil 
              surroundings make Shenbaga Devi Falls one of the most beautiful and spiritually 
              significant waterfalls in the Courtallam region. Combining natural beauty, religious 
              importance, and adventure, Shenbaga Devi Falls offers visitors a memorable experience 
              and remains one of the must-visit attractions near Courtallam.
            </p>
          </div>
        </div>

        {/* Shenbagadevi */}
        <div className="row align-items-center place-row mb-5">
          <div className="col-lg-6">
            <img src={shenbagadevi} alt="Shenbagadevi Falls" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Tiger Falls</h2>
            <p>
              Tiger Falls, locally known as Puliyaruvi, is one of the most peaceful and 
              family-friendly waterfalls in Courtallam, located in the Tenkasi district of Tamil Nadu.
              Situated a short distance from the famous Main Falls, Tiger Falls is known for its 
              gentle flow of water and calm surroundings, making it an ideal destination for 
              families with children and elderly visitors. Unlike the larger waterfalls in Courtallam,
              the water here falls from a lower height, creating a safe and refreshing natural shower.
              The waterfall is surrounded by lush greenery and the beautiful landscapes of the Western
              Ghats, providing a cool and relaxing atmosphere throughout the year. The clear water is 
              believed to possess medicinal qualities because it flows through forests rich in herbal 
              plants. Visitors enjoy bathing, relaxing, and taking photographs in the serene 
              environment. The best time to visit Tiger Falls is during the monsoon season, from 
              June to September, when the water flow is abundant and the surrounding vegetation is 
              at its greenest. The peaceful ambience, easy accessibility, and natural beauty make 
              Tiger Falls one of the most popular attractions for tourists visiting Courtallam.
            </p>
          </div>
        </div>

        {/* Chitraruvi */}
        <div className="row align-items-center place-row">
          <div className="col-lg-6">
            <img src={chitraruvi} alt="Chitraruvi" className="place-img" />
          </div>

          <div className="col-lg-6">
            <h2>Thirumalai Kumaraswamy Temple</h2>
            <p>
              The Thirumalai Murugan Temple, also known as Thirumalai Kumaraswamy Temple, is a 
              famous hill temple dedicated to Lord Murugan, located at Panpozhi near Tenkasi, about 
              18 kilometres from Courtallam. Nestled amidst the scenic Western Ghats, the temple stand
              s on a hill and offers breathtaking views of the surrounding valleys, green fields, and 
              mountain ranges. The temple is believed to have great historical and spiritual 
              significance, and it has been praised in the hymns of the saint Arunagirinathar. 
              According to local tradition, Lord Murugan appeared here to bless Sage Agastya, making 
              the temple an important pilgrimage centre for devotees. The presiding deity, Thirumalai 
              Kumaraswamy, is seen in a unique standing posture with four hands, symbolizing divine 
              power and protection. Visitors can reach the temple either by climbing hundreds of steps 
              or by using the hill road that leads directly to the temple complex. The hill itself is 
              considered sacred, and many devotees undertake the climb as an act of devotion.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Places;